import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarItem, useToast, Button } from '@kinesis/bungle';
import { useIsEditor } from '@/hooks/use-is-editor';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNewScenarioMutation } from '@/api/scenarios';

const ToolbarPathways = () => {
  const [newScenario, { isLoading: isCreating }] = useNewScenarioMutation();
  const navigate = useNavigate();
  const inventoryId = useInventoryId();
  const toast = useToast('globalTop');
  const isEditor = useIsEditor();

  const onCreateScenario = useCallback(async () => {
    try {
      const data = await newScenario({
        inventoryId,
        name: 'New scenario',
      }).unwrap();
      navigate(`/communities/${inventoryId}/pathways/${data.id}`);
    } catch (e) {
      toast('Could not create scenario.', { variant: 'error' });
    }
  }, [newScenario, inventoryId, navigate, toast]);

  return isEditor ? (
    <>
      <ToolbarItem>
        <Button
          onClick={onCreateScenario}
          variant='primary'
          loading={isCreating}
        >
          New scenario
        </Button>
      </ToolbarItem>
    </>
  ) : null;
};

export { ToolbarPathways };
